import React from 'react'
import { graphql } from "gatsby"
import styled from 'styled-components'
import Layout from "../layouts/Layout"

import { getCookie, setCookie, eraseCookie } from '../layouts/functions'

/* eslint-disable */

import ElementSelector from '../components/index-parts/ElementSelector'
import Weather from '../components/index-parts/Weather'
import UpcomingEvent from '../components/index-parts/UpcomingEvent'
import PlaceCard from '../components/place-card/PlaceCard'
import EventCard from '../components/event-card/EventCard'
import ChiSiamo from '../components/extra-pages/ChiSiamo'
import IlPaese from '../components/extra-pages/IlPaese'

// Special Camminando Mangiando
import SpecialCMCard from '../components/special-CM/SpecialCMCard'
import Newsletter from '../components/generals/Newsletter'

const IndexPageStyle = styled.div`
  padding: 20px;
  padding-top: 0;
  margin-top: 55px;

  .indexPageExtraInfo {
    display: grid;
    grid-template-columns: 90px 1fr;
    // align-items: center;
    // justify-content: space-between;
    margin-top: 20px;
  }

  .indexPageStyleCardContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    margin-top: 20px;
  }

  @media screen and (max-width: 1112px) {
    .indexPageStyleCardContainer {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media screen and (max-width: 800px) {
    .indexPageStyleCardContainer {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (max-width: 375px) {
    padding: 12px;
    margin-top: 45px;
  }

  @media screen and (max-width: 320px) {
    padding: 10px;
    margin-top: 45px;
  }
`;

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);

    if(!getCookie('indexPageElementDisplayed')) {
      setCookie('indexPageElementDisplayed', 1, 1);
    }
  }

  state = {
    elementDisplayed: 1
  }

  handleChange(event) {
    var integer = parseInt(event.target.value, 10);
    this.setState({elementDisplayed: integer});
    eraseCookie('indexPageElementDisplayed');
    setCookie('indexPageElementDisplayed', integer, 1);
  }

  UNSAFE_componentWillMount = () => {
    if (getCookie('indexPageElementDisplayed') != '1') {
      this.setState({
        elementDisplayed: parseInt(getCookie('indexPageElementDisplayed'), 10)
      })
    } else {
      return
    }
  }

  render() {
    const { data, location } = this.props;
    return (
      <Layout location={location}>
        <IndexPageStyle>
          <ElementSelector data={data} elementDisplayedState={this.state.elementDisplayed} changeState={this.handleChange} />
          <div className="indexPageExtraInfo">
            <Weather />
            <UpcomingEvent data={data}/>
          </div>
          <div className="indexPageStyleCardContainer">
            {this.state.elementDisplayed == 1 && <SpecialCMCard />}
            {this.state.elementDisplayed == 1 && navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) && <Newsletter />}
            {this.state.elementDisplayed == 1 &&
              data.allMarkdownRemark.edges.map(({ node }, i) => {
                if (node.frontmatter.element === 1) {
                  return <PlaceCard key={node.id} place={node}/>
                }
              })
            }
            {this.state.elementDisplayed == 2 && <Newsletter />}
            {this.state.elementDisplayed == 2 &&
              data.allMarkdownRemark.edges.map(({ node }, i) => {
                if (node.frontmatter.element === 2) {
                  return <EventCard key={node.id} place={node}/>
                }
              })
            }
            {this.state.elementDisplayed == 4 && <ChiSiamo />}
            {this.state.elementDisplayed == 5 && <IlPaese />}
          </div>
        </IndexPageStyle>
      </Layout>
    )
  }
}

export const query = graphql`
  query SitePost {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            element
            name
            type
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 3000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            latitude
            longitude
            locality
            date(formatString: "DD/MM/YYYY")
            dateCountDown(difference: "days")
          }
          id
          html
          excerpt
        }
      }
    }
  }
`;